import uniqueId from "lodash/uniqueId";

/**
 * для генерации уникальных идентификаторов
 * @returns 
 */
export const useId = () => {
  return uniqueId('app_id_');
};
